import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Wed, 12 Apr 2:31PM ( BRT ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.3Rg4LXqQ6fLu00Ta2SwpKEOvbRErOt4TPJ1WDFID3uUxq4Yx3PtjECDkXqYWoZ95lfCSXzs6ukWZcoNNLKtySCf5p2e_UyYpUaYHJWKF-nhZrwjwmBipnUkM5GW0BkINvk8v9UpTkTBtTIPmz0xffaJy341Dz3dkDsD7uxwjVdQaGCA5r5cwqQDy3ocrWy8uXSbepnFMeVn2HwbJmTbFYPlRUZfoF5ydBsL1XRDhC2e4arJgkrDoOmjM2Vq581jBB4Qjhmb740TGR-4h6p38pALfJMnpM9E",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-04-19T17:32:37.924258Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2024-04-12T17:32:29+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.3Rg4LXqQ6fLu00Ta2SwpKEOvbRErOt4TPJ1WDFID3uUxq4Yx3PtjECDkXqYWoZ95lfCSXzs6ukWZcoNNLKtySCf5p2e_UyYpUaYHJWKF-nhZrwjwmBipnUkM5GW0BkINvk8v9UpTkTBtTIPmz0xffaJy341Dz3dkDsD7uxwjVdQaGCA5r5cwqQDy3ocrWy8uXSbepnFMeVn2HwbJmTbFYPlRUZfoF5ydBsL1XRDhC2e4arJgkrDoOmjM2Vq581jBB4Qjhmb740TGR-4h6p38pALfJMnpM9E'

// {
//   "access_token": "v2.local.oYvG527rm09s1dJIA-7xiik3G-rsjHGxGpjQA0ULRbbMhDogSQV6NRCn7Vx7LThzOPqRdJuZxKQoU_FR4N70MZ0qRIBPq2u_WZ8bmv7fDBbErfarO2_ZWif8QMz9tuPBgu9Z2WVhhv8U-hRw0DWMBc9vpJ6W4joz5q6O_Tglt0nxJOwxfIEmOHc8hewxt65157lgwxZvndcIEAX_u5iYwnVSde9g8N5xiL7W5iu4DoiO4tJCrCt8becrkbT54nOkeLezjuTtneu3ub7R-GDJJdTfkoCL4bE",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-04-19T17:33:51.265795Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2024-04-12T17:33:45+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.oYvG527rm09s1dJIA-7xiik3G-rsjHGxGpjQA0ULRbbMhDogSQV6NRCn7Vx7LThzOPqRdJuZxKQoU_FR4N70MZ0qRIBPq2u_WZ8bmv7fDBbErfarO2_ZWif8QMz9tuPBgu9Z2WVhhv8U-hRw0DWMBc9vpJ6W4joz5q6O_Tglt0nxJOwxfIEmOHc8hewxt65157lgwxZvndcIEAX_u5iYwnVSde9g8N5xiL7W5iu4DoiO4tJCrCt8becrkbT54nOkeLezjuTtneu3ub7R-GDJJdTfkoCL4bE'

// {
//   "access_token": "v2.local.iv4wVo9NDUU4O3XrqrTD4ptUw5V8jZOkNaI5pBXlBjhsOkq-bQbbEfWatR6F6bcYJk60SEnwrC40Cso7GdHEg7bhM85txnhevTMMR9VlY6NVeswAkzta3UZHA2R79FPpH9crCRWUdupVXobvK6C63AfHzzOfq4ziM5r3syfzC3HO84WPA_O5uXM2jHS5IkGC9TeIupY66-7dZUT1nHeRYjWFOPiKB1ZoFAeTYUN74koANaa6LxQTfucW0jO5Z4lFn-YjIyT5asaeuM3ijcrf6ZCj9ehX",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-04-19T17:30:51.845664Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.iv4wVo9NDUU4O3XrqrTD4ptUw5V8jZOkNaI5pBXlBjhsOkq-bQbbEfWatR6F6bcYJk60SEnwrC40Cso7GdHEg7bhM85txnhevTMMR9VlY6NVeswAkzta3UZHA2R79FPpH9crCRWUdupVXobvK6C63AfHzzOfq4ziM5r3syfzC3HO84WPA_O5uXM2jHS5IkGC9TeIupY66-7dZUT1nHeRYjWFOPiKB1ZoFAeTYUN74koANaa6LxQTfucW0jO5Z4lFn-YjIyT5asaeuM3ijcrf6ZCj9ehX'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
